module.exports = __webpack_public_path__ + "img/arrow.57c46ef.svg";